<template>
    <modal ref="modal">
        <div id="sub-wrapper">
            <form @submit="submit">
              <div class="title">{{ $t('modals.text_update.title') }}</div>
              <div>
                  <label>{{ $t('labels.text') }} *</label>
                  <input ref="text" v-model="text.text" type="text" :class="errors['text'] ? 'error' : ''"/>
                  <div class="error" v-if="errors['text']">{{ errors['text'] }}</div>
              </div>
              <div>
                  <label>{{ $t('labels.font') }} *</label>
                  <selector v-model="text.font_name" :options='fontOptions()' :html='fontHTML'/>
              </div>
              <div>
                  <label>{{ $t('labels.font_size') }} *</label>
                  <selector v-model="text.font_size" :options='fontSizeOptions()' :html='fontSizeHTML'/>
              </div>
              <div>
                  <label>{{ $t('labels.font_color') }} *</label>
                  <selector v-model="text.font_color" :options='colorOptions()' :html='colorHTML'/>
              </div>
              <button>{{ $t('modals.text_update.button') }}</button>
            </form>
        </div>
    </modal>
</template>

<script>
import event from '@/services/event'

export default {
  props: {
    colors: Array,
    fonts: Array,
    fontSizes: Array
  },
  data () {
    return {
      defaultErrKey: 'text',
      errors: {},
      text: {}
    }
  },
  methods: {
    show (text) {
      this.text = Object.assign({}, text)
      this.$refs.modal.show()
      this.$nextTick(function () {
        this.$refs.text.focus()
      }.bind(this))
    },
    hide () {
      this.$refs.modal.hide()
    },
    fontOptions () {
      var r = []
      this.fonts.forEach(i => r.push({ value: i }))
      return r
    },
    fontHTML (i) {
      return `<div style="font-family:'` + i.value + `';line-height: 1em">` + i.value + `</div>`
    },
    fontSizeOptions () {
      var r = []
      this.fontSizes.forEach(i => r.push({ value: i.name }))
      return r
    },
    fontSizeHTML (i) {
      return i.value
    },
    colorOptions () {
      var r = []
      this.colors.forEach(i => r.push({
        _value: i.value,
        value: i.name
      }))
      return r
    },
    colorHTML (i) {
      return `<div style="align-items:center;display:flex;flex-direction:row">
        <div style="border:solid 1px #000000;border-radius:50%;background-color:#` + i._value.toString(16).padStart(6, '0') + `;height:1.2em;width:1.2em"></div>
        <div style="margin-left:0.5em">` + i.value + `</div>
      </div>`
    },
    submit (e) {
      // Init
      e.preventDefault()
      this.errors = {}

      // Check text
      if (!this.text.text || this.text.text === '') {
        this.errors = { 'text': this.$i18n.t('mandatory.text') }
        return
      }

      // Show loader
      this.$parent.$parent.$parent.$refs.loader.show()

      // Update text
      event.updateText(this.text.id, this.text)
        .then(() => {
          // Hide loader
          this.$parent.$parent.$parent.$refs.loader.hide()

          // Hide modal
          this.hide()
        })
        .catch(err => {
          // Hide loader
          this.$parent.$parent.$parent.$refs.loader.hide()

          // Update error
          if (err.messages) {
            this.errors = err.messages
          } else {
            this.errors = {}
            this.errors[this.defaultErrKey] = this.$i18n.t('errors.default')
          }
        })
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 25em;
}

</style>
